module.exports = __webpack_public_path__ + "img/line1.21fca549.png";